import { jsx as _jsx } from "react/jsx-runtime";
/* Card — surface (default) and sunken variants.
 *
 * Radius: 12px (--radius-md).
 * Default padding: 24px (compact 16px, dense 12px).
 * Hairline border, lifted shadow on surface variant. */
import { forwardRef } from 'react';
const densityPadding = {
    default: '24px',
    compact: '16px',
    dense: '12px',
};
function variantStyles(variant) {
    switch (variant) {
        case 'surface':
            return {
                background: 'var(--bg-surface)',
                border: '1px solid var(--border-hairline)',
                boxShadow: 'var(--shadow-lifted)',
            };
        case 'sunken':
            return {
                background: 'var(--bg-sunken)',
                border: '1px solid transparent',
                boxShadow: 'none',
            };
        case 'elevated':
            return {
                background: 'var(--bg-elevated)',
                border: '1px solid var(--border-hairline)',
                boxShadow: 'var(--shadow-floating)',
            };
    }
}
export const Card = forwardRef(function Card({ variant = 'surface', density = 'default', style, children, ...rest }, ref) {
    const merged = {
        borderRadius: 'var(--radius-md)',
        padding: densityPadding[density],
        color: 'var(--ink-primary)',
        ...variantStyles(variant),
        ...style,
    };
    return (_jsx("div", { ref: ref, style: merged, ...rest, children: children }));
});
//# sourceMappingURL=Card.js.map